import React from 'react';

import SelectCodeRow from './Row';
import SelectCodeColumn from './Column';

import { SecretCodeSelectProps, DisplayDirection } from './types';

interface SelectProps extends SecretCodeSelectProps {
  displayDirection: DisplayDirection;
}

const SecretCodeSelect = ({ displayDirection, ...props }: SelectProps): React.ReactElement => {
  return displayDirection === DisplayDirection.ROW ? (
    <SelectCodeRow {...props} />
  ) : (
    <SelectCodeColumn {...props} />
  );
};

export default SecretCodeSelect;
